export function normalizeTranslationValue(value: unknown, fallback = ""): string {
  if (typeof value === "string") return value;
  if (value === null || value === undefined) return fallback;
  if (typeof value === "number" || typeof value === "boolean") return String(value);

  if (typeof value === "object" && value !== null && "text" in value) {
    const text = (value as { text?: unknown }).text;
    if (typeof text === "string") return text;
    if (text === null || text === undefined) return fallback;
    return String(text);
  }

  // For unexpected objects/arrays, do NOT stringify for UI (would look broken).
  return fallback;
}

export function sanitizeTranslationCache(raw: unknown): Record<string, Record<string, string>> {
  if (!raw || typeof raw !== "object") return {};

  const out: Record<string, Record<string, string>> = {};
  for (const [cacheKey, perLang] of Object.entries(raw as Record<string, unknown>)) {
    if (!perLang || typeof perLang !== "object") continue;

    const normalizedPerLang: Record<string, string> = {};
    for (const [lang, val] of Object.entries(perLang as Record<string, unknown>)) {
      const normalized = normalizeTranslationValue(val, "");
      if (normalized) normalizedPerLang[lang] = normalized;
    }

    if (Object.keys(normalizedPerLang).length > 0) out[cacheKey] = normalizedPerLang;
  }

  return out;
}
